var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.rowElement,
    _vm._b(
      {
        tag: "component",
        class: { error: _vm.hasErrorsBoth },
        attrs: { label: _vm.label, error: _vm.activeErrorMessagesBoth },
      },
      "component",
      _vm.$attrs,
      false
    ),
    [
      _vm._t("default", null, {
        errors: _vm.activeErrors,
        events: _vm.events,
        firstErrorMessage: _vm.activeErrorMessagesBoth,
        hasErrors: _vm.hasErrorsBoth,
        validator: _vm.preferredValidator,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }